import React, { useEffect, forwardRef, useRef, useState } from "react";
import "./Interact.css";
import { PeoplChatBubbleIcon, PeoplLocBubbleIcon, PeoplJoinBubbleIcon } from "../../../../assets/icons/DialogCustomIcon";
import DialogContent from "@mui/material/DialogContent";
import TuneIcon from "@mui/icons-material/Tune";
import { Tooltip, MenuItem, OutlinedInput, Select } from "@mui/material";
import { useTranslation } from 'react-i18next'
import { getConnectedUsers, joinRoom } from "../../store/interact/interactThunks";
import { setActiveTab, setFilter, setSearchTerm, createDebouncedSearch, setRooms } from "../../store/interact/interactSlice";
import { useSelector, useDispatch } from "react-redux";
import { setOpenModal, setUserToVisitMapId, setChangeMapType } from "../../store/controlPanelSlice.js";
import { intializeMessageDialog, setSelectedConversationId} from '../../../../store/messagesSlice/messagesSlice.js';
import { setFocusedAvatarId } from '../../../Map/store/MapDisplaySlice.js';
import { createRoomHasPermission, hasPermission, tenantHasFeature } from "../../../Auth/utils/AuthUtils.js";
import { isEqual } from "date-fns";
import MapIcon from "@mui/icons-material/Map";
import { setJoinBy, setTargetRoom } from "../../../ProductivitySession/store/ProductivitySessionSlice.js";
import { addNotification } from "../../../Notifications/store/notificationsSlice.js";
import { getConferenceUserParams } from "../../../../utils/conferenceUtils.js";
import NotificationBuilder from "../../../Notifications/utils/NotificationBuilder.js";




const Interact = ({ isChatEnabled, isGroupMessageEnabled }) => {

  const CustomIcon = forwardRef((props, ref) => (
    <svg {...props} width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 1.5L5.5 5.5L9.5 1.5" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ));

  const { localAvatar } = useSelector((state) => state.auth);
  const { currentRoom } = useSelector((state) => state.MapDisplay);
  const {sessionView} = useSelector((state) => state.productivitySession)
  const { activeTab, filter, searchTerm, filteredUserList, filteredRoomList, loading, userIdList } = useSelector((state) => state.interactModal);
  const { roomsData, mapConfig, maps } = useSelector((state) => state.MapDisplay);
  const { avatars } = useSelector((state) => state.avatars);
  const { uiState,conference } = useSelector((state) => state.activeConference);
  const avatarsData = useSelector((state) => state.avatars?.avatars || {});
  const listRef = useRef(null);
  const [paginationPage, setPaginationPage] = useState(1);

  const dispatch = useDispatch();

  const debouncedSearch = createDebouncedSearch(dispatch);

  const { t } = useTranslation();

  const filters = ["-","A → Z", "Z → A"];

  useEffect(() => {
    if (activeTab === "rooms")
      dispatch(setRooms(roomsData));
    else if (activeTab === "users") {
      dispatch(getConnectedUsers());
      setPaginationPage(1);
    }
  }, [activeTab, filteredRoomList.length, roomsData, avatars]);

  const handleSearch = (e) => {
    dispatch(setSearchTerm(e.target.value));
    debouncedSearch();
    setPaginationPage(1);
  }

  const onMessageClick = (user) => {
    dispatch(intializeMessageDialog({ isRoom: false, target: user }));
    dispatch(setOpenModal("message_dialog"));
  }

  const onUserClick = (userId) => {
    dispatch(setFocusedAvatarId(userId));
    dispatch(setOpenModal(null))
  }

  const onRoomMessageClick = (room) => {
    dispatch(intializeMessageDialog({ isRoom: true, target: room }));
    dispatch(setOpenModal("message_dialog"));
  }

  const handleJoinRoom = (targetRoomId) => {
    dispatch(joinRoom({ body: { targetRoomId } }));
    dispatch(setOpenModal(null))
  }

  const { isAccessTypeRoom } = getConferenceUserParams(
      conference, 
      avatarsData, 
      localAvatar, 
      uiState.is_conference_active
  );
  
  useEffect(() => {
    setPaginationPage(1);
  }, [filter]);

  useEffect(() => {
    const listEl = listRef.current;
    if (!listEl) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = listEl;

      const nearBottom = scrollTop + clientHeight >= scrollHeight / 2;
      if (
        nearBottom &&
        paginationPage * 5 < filteredUserList.length
      ) {
        setPaginationPage((prev) => prev + 1);

      }
    };

    listEl.addEventListener("scroll", handleScroll);
    return () => listEl.removeEventListener("scroll", handleScroll);
  }, [filteredUserList, paginationPage]);

  return (
    <DialogContent className="gestion-user-dialog-content" >
      <div className="invitation-tabs" style={{ marginBottom: "2rem" }}>
        <button onClick={() => dispatch(setActiveTab("users"))}
          type="button"
          className={`invitation-tab ${activeTab === "users" ? "active" : ""}`}
          sx={
            { width: "50%" }
          }
        >
          <span className="material-symbols-outlined">
            work_history
          </span>
          {t("users")}
        </button>
        <button onClick={() => dispatch(setActiveTab("rooms"))}
          type="button"
          className={`invitation-tab  ${activeTab === "rooms" ? "active" : ""}`}
          sx={
            { width: "50%" }
          }
        >
          <span class="material-symbols-outlined">
            event_note
          </span>
          {t("rooms")}
        </button>
      </div>

      <div className="gestion-user-dialog-selectors" style={{ marginBottom: "2rem", }}>
        <Select
          className="gestion-user-dialog-filters"
          displayEmpty
          value={filters ? filters[filter] : t("filter_by")}
          onChange={(e) => dispatch(setFilter(filters.indexOf(e.target.value)))}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            return (
              <>
                <TuneIcon /> <span className="label-filter">{t("filter_by")}</span> {selected}
              </>
            )
          }}
          inputProps={{ 'aria-label': 'Without label' }}
          IconComponent={CustomIcon}
        >

          <MenuItem disabled value={t("filter_by")}>
            <TuneIcon /> {t("filter_by")}
          </MenuItem>
          {filters.map((f) => (
            <MenuItem key={f} value={f} >
              {f}
            </MenuItem>
          ))}
        </Select>
        <div className="gestion-user-dialog-search-bar">
          <input
            type="text"
            placeholder={`${activeTab === "users" ? t("search_for_a_user") : t("search_for_a_room")}...`}
            value={searchTerm}
            onChange={(e) => handleSearch(e)}
          />
        </div>
      </div>

      {activeTab === "users" && (
        <div className="liste-interact-container">
          <ul className="user-interact-list" ref={listRef} >
            {filteredUserList.length > 0 ? (
              filteredUserList.slice(0, paginationPage * 10).map((user, index) => (
                <li key={index} className="gestion-user-dialog-user-item">
                  <div className="user-info">
                    <strong className="user-name">{user.display_name}</strong>
                    <span className={`status ${user.online ? "online" : "offline"}`}>
                      <span className="status-indicator">
                      </span>
                      {user.online ? t("online") : t("offline")}
                      {user.online && user.email !== localAvatar.email && (
                        <>
                          {
                          /*
                          user.map_id === mapConfig.mapId && (
                            <span className="same-map-label">
                              <MapIcon className="map-icon" />
                              {t("SAME_MAP")}
                            </span>
                          )*/} 

                            <span className="same-map-label">
                              <MapIcon className="map-icon" />
                              {maps.find(m => m.id === user.map_id)?.name}
                            </span>
                        </>
                      )}
                    </span>
                  </div>

                  <div className="gestion-user-dialog-icons">
                    {isChatEnabled && (
                      <Tooltip title={t("SEND_MESSAGE")} placement="top" PopperProps={{
                        container: document.querySelector('.MuiDialog-root'),
                      }}
                        slotProps={{
                          popper: {
                            sx: { zIndex: 10012 },
                          },
                        }}>
                        <div className="icon-wrapper">
                          {tenantHasFeature("USER_CHAT_ENABLED") && hasPermission("sendMessageToUser") && user.email !== localAvatar.email &&
                            <PeoplChatBubbleIcon
                              className={`gestion-user-dialog-chat-icon ${user.email === localAvatar.email ? "disabled-icon" : ""}`}
                              onClick={() => {
                                if (user.email !== localAvatar.email) {
                                  //onMessageClick(user);
                                  dispatch(setSelectedConversationId(user.id));
                                  dispatch(setOpenModal("message_history"));
                                  
                                } else {
                                  console.warn("Action désactivée : vous ne pouvez pas vous envoyer un message.");
                                }
                              }}
                              style={{
                                pointerEvents: user.email === localAvatar.email ? "none" : "auto",
                                opacity: user.email === localAvatar.email ? 0.5 : 1,
                                cursor: user.email === localAvatar.email ? "not-allowed" : "pointer",
                              }}
                            />
                          }

                        </div>
                      </Tooltip>
                    )}
                    <div className="icon-wrapper">
                      {(() => {
                        const isOfflineOrInaccessible =
                          !user.online || (user.map_id !== mapConfig.mapId && !maps.some(m => m.id === user.map_id));

                        const isSameMap = user.online && user.map_id === mapConfig.mapId;

                        const isDifferentAccessibleMap = user.online && user.map_id !== mapConfig.mapId && maps.some(m => m.id === user.map_id);
                        let tooltipMessage = "";
                        if (
                          user.map_id !== mapConfig.mapId &&
                          !maps.some((m) => m.id === user.map_id)
                        ) {
                          tooltipMessage = t("MAP_INACCESSIBLE");
                        }
                        else if (isSameMap || isDifferentAccessibleMap) {
                          tooltipMessage = t("LOCATE");
                        }
                        return (
                          <Tooltip
                            title={tooltipMessage}
                            placement="top"
                            PopperProps={{
                              container: document.querySelector('.MuiDialog-root'),
                            }} slotProps={{
                              popper: {
                                sx: { zIndex: 10009 },
                              },
                            }}
                          >
                            <div>
                              <PeoplLocBubbleIcon
                                alt={tooltipMessage}
                                className={`gestion-user-dialog-icon-map ${isOfflineOrInaccessible ? "disabled" : ""}`}
                                onClick={() => {
                                  if (isOfflineOrInaccessible) return;
                                  if (isSameMap) {
                                    onUserClick(user.id);
                                  } else if (isDifferentAccessibleMap) {
                                    dispatch(setChangeMapType("interact"));
                                    dispatch(setUserToVisitMapId(user.map_id));
                                    dispatch(setFocusedAvatarId(user.id));
                                    dispatch(setOpenModal("confirm_change_map"));
                                  }
                                }}
                                style={{
                                  cursor: isOfflineOrInaccessible ? "not-allowed" : "pointer",
                                }}
                              />
                            </div>
                          </Tooltip>
                        );
                      })()}
                    </div>
                  </div>
                </li>
              ))
            ) : !loading && (
              <p className="no-users">{t("no_users_found")}</p>
            )}
          </ul>
        </div>
      )}

      {activeTab === "rooms" && (
        // 🔹 Liste des rooms
        <div className="liste-interact-container">
          <ul className="gestion-user-dialog-room-list">
            {filteredRoomList.length > 0 ? (filteredRoomList.map((room, index) => {
              const isUserInRoom = room.id === currentRoom?.room_id;
              const roomHasPermission = createRoomHasPermission(room.roomPermissions || []);

              return (
                <li key={index} className="gestion-user-dialog-room-item">
                  <div className="gestion-user-dialog-room-info">
                    <strong className="gestion-user-dialog-room-name">{room.label}</strong>
                    <span className="gestion-user-dialog-room-members">{t("capacity")} {room?.chair_count} {t("persons")}</span>
                  </div>
                  <div className="gestion-user-dialog-icons">
                    {(tenantHasFeature("ROOM_CHAT_ENABLED") && roomHasPermission("sendMessageToRoom")) && (
                      <Tooltip title="Envoyer un message" placement="top" PopperProps={{
                        container: document.querySelector('.MuiDialog-root'),
                      }}>
                        <div className="icon-wrapper">
                          <PeoplChatBubbleIcon
                            className={`gestion-user-dialog-chat-icon`}
                            onClick={() => {
                              onRoomMessageClick(room);
                            }}
                          />
                        </div>
                      </Tooltip>
                    )}
                    <Tooltip title="Entrer dans la salle" placement="top" PopperProps={{
                      container: document.querySelector('.MuiDialog-root'),
                    }}>
                      <div className="icon-wrapper">
                        <PeoplJoinBubbleIcon
                          className={`gestion-user-dialog-icon-door ${isUserInRoom ? "disabled" : ""}`}
                          onClick={() => {
                            if(isAccessTypeRoom){
                                const notification = NotificationBuilder.error()
                                .withHeader('cant_move')
                                .build()
                                dispatch(addNotification(notification));                                           
                              }
                            else{
                            if (!isUserInRoom) {
                              if(sessionView !== "progress" && localAvatar?.focus_state === 0){
                                handleJoinRoom(room.room_id);
                              }  
                              else if( sessionView === "progress" && localAvatar?.focus_state === 1){
                                dispatch(setJoinBy("room"));
                                dispatch(setTargetRoom(room.room_id));
                                dispatch(setOpenModal("stop_focus"));
                              }
                            } else {
                              console.warn("L'utilisateur est déjà dans la room, action annulée.");
                            }}
                          }}
                        />
                      </div>
                    </Tooltip>
                  </div>
                </li>
              );
            }
            )
            ) : !loading &&
            (
              <p className="no-users">{t("no_rooms_found")}</p>
            )
            }
          </ul>
        </div>
      )}
    </DialogContent>
  );
};

export default Interact;
